/**
 * Mortar Tank — Bread and butter. Good damage, big booms, trick shots.
 */

import { registerWeapon } from '../weapons';
import { registerTank } from './registry';
import { DEFAULT_CRATER, HUGE_CRATER } from '../terrain/crater-shapes';

// Shot 1: Shell — identical to existing MORTAR
const MORTAR_SHOT1 = registerWeapon({
  id: 'mortar_shot1',
  name: 'Shell',
  description: 'Standard mortar shell. Free to fire.',
  tier: 'CHEAP',
  rarity: 'common',
  projectileRadius: 8,
  projectileSpeed: 0.55,
  color: 0x00ffff,
  gravity: 0.15,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 25,           // S1 nerf: was 38
  blastRadius: 100,
  knockbackMult: 0.08,
  knockbackRadius: 1.2,
  shakeIntensity: 2.5,
  particleScale: 1.5,
  craterShape: DEFAULT_CRATER,
  edgeguard: { chargeFrames: 30, threshold: 45 },
  // Subtle cyan glow trail — standard shell, light identity
  onTick(proj, _state, fx) {
    proj.behaviorState.t = (proj.behaviorState.t || 0) + 1;
    if (proj.behaviorState.t % 4 === 0) {
      fx.push({ type: 'particles', method: 'spawnParticle', args: [
        proj.x, proj.y, 0x00ffff,
        0.1, 0.5, 0.06, 0.1, 0.15, 0.3, 0, 0.93, true, false, 0.3,
      ] });
    }
    return null;
  },
});

// Shot 2: Heavy Shell — slower, bigger, costlier
const MORTAR_SHOT2 = registerWeapon({
  id: 'mortar_shot2',
  name: 'Heavy Shell',
  description: 'Slow but devastating. Massive crater and knockback.',
  tier: 'UNCOMMON',
  rarity: 'uncommon',
  projectileRadius: 14,
  projectileSpeed: 0.35,
  color: 0x00ffff,
  gravity: 0.22,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 52,
  blastRadius: 130,
  knockbackMult: 0.104,
  knockbackRadius: 1.4,
  shakeIntensity: 2.0,
  particleScale: 2.0,
  craterShape: HUGE_CRATER,
  edgeguard: { chargeFrames: 40, threshold: 50 },
  // Visual identity — grenade launcher thump + pulsing energy projectile
  muzzleEffect: 'spawnHeavyMuzzleFlash',
  muzzleShakeIntensity: 18,
  pulseEffect: true,
  // Heavy shell — dark smoke wisps + cyan glow trail (artillery weight)
  onTick(proj, _state, fx) {
    proj.behaviorState.t = (proj.behaviorState.t || 0) + 1;
    // Smoke wisps every 3 frames — NORMAL blend, dark
    if (proj.behaviorState.t % 3 === 0) {
      const smokeColor = Math.random() < 0.5 ? 0x223333 : 0x112222;
      fx.push({ type: 'particles', method: 'spawnParticle', args: [
        proj.x + (Math.random() - 0.5) * 6,
        proj.y + (Math.random() - 0.5) * 6,
        smokeColor,
        0.3, 1.0, 0.15, 0.3,
        0.4, 0.8,
        -0.01, 0.97,
        false, false, // NORMAL, soft — dark smoke
        0.4,
      ] });
    }
    // Cyan energy glow every 4 frames
    if (proj.behaviorState.t % 4 === 0) {
      fx.push({ type: 'particles', method: 'spawnParticle', args: [
        proj.x, proj.y, 0x00ffff,
        0.1, 0.5, 0.06, 0.12, 0.2, 0.4, 0, 0.93, true, false, 0.4,
      ] });
    }
    return null;
  },
});

registerTank({
  id: 'mortar',
  name: 'Mortar',
  description: 'Bread and butter. Good damage, big booms, trick shots.',
  visual: { bodyColor: 0x22AAAA, glowColor: 0x44DDDD, bodyRadius: 35 },
  ecbRadius: 27,
  shots: [
    { tier: 1, weapon: MORTAR_SHOT1, momentumCost: 0, hitlagBonus: 0, label: 'Shell', tierColor: 0xaaaaaa },
    { tier: 2, weapon: MORTAR_SHOT2, momentumCost: 0, hitlagBonus: 0, label: 'Heavy Shell', tierColor: 0xffd700 },
  ],
});
